import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';

export default function OrderDetailInfoTable(props) {
    const classes = useStyles();
    const { t } = useTranslation();   

    return (
        <TableContainer component={Paper} className={classes.paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableBody>
                    {props.rows.map((row) => (
                        <TableRow key={row.name} className={classes.row}>
                            <TableCell className={classes.nameCell}>
                                {t(row.name)}
                            </TableCell>
                            <TableCell className={classes.infoCell}>{row.info}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        )
}

const useStyles = makeStyles({  
  
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "120px"
    },
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    paper: {
        boxShadow: 'none'
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },   
});